<template>
  <v-container fluid class="asc-analytic-watchlist-list-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <asc-analytic-watchlist-grid-wrapper
          :title="title"
          :values="values"
          :on-open="onOpen"
          :on-date-change="onDateChange"
          :day-selected="daySelected"
          :filter-start-date="filterStartDate"
          :filter-end-date="filterEndDate"
          :grid-filters="gridFilters"
        ></asc-analytic-watchlist-grid-wrapper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import { AscAnalyticWatchlistGridWrapper } from '@/components/organisms'

export default {
  name: 'AscAnalyticWatchlistListTemplate',

  components: {
    AscAnalyticWatchlistGridWrapper,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],
}
</script>

<style lang="scss" scoped>
.asc-analytic-watchlist-list-template {
  background-color: $gray-100;
}
</style>
